import { FaFacebookF, FaWhatsapp, FaLinkedinIn, FaXTwitter } from "react-icons/fa6";
import { Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export const ShareBar = ({ title, orientation = "vertical" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const enc = encodeURIComponent;

  const shares = [
    { name: "Facebook", icon: FaFacebookF, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { name: "X", icon: FaXTwitter, href: `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}` },
    { name: "WhatsApp", icon: FaWhatsapp, href: `https://wa.me/?text=${enc(title + " " + url)}` },
    { name: "LinkedIn", icon: FaLinkedinIn, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copiato negli appunti");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const wrap =
    orientation === "vertical"
      ? "flex flex-col gap-3"
      : "flex flex-row gap-3 items-center";

  return (
    <div className={wrap} data-testid="share-bar">
      {orientation === "horizontal" && (
        <span className="label-ui text-[#57534E] mr-1">Condividi</span>
      )}
      {shares.map((s) => (
        <a
          key={s.name}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Condividi su ${s.name}`}
          data-testid={`share-${s.name.toLowerCase()}`}
          className="w-10 h-10 flex items-center justify-center border border-[#E7E5E4] text-[#57534E] hover:bg-[#1C1917] hover:text-white hover:border-[#1C1917] transition-colors"
        >
          <s.icon size={15} />
        </a>
      ))}
      <button
        onClick={copy}
        aria-label="Copia link"
        data-testid="share-copy"
        className="w-10 h-10 flex items-center justify-center border border-[#E7E5E4] text-[#57534E] hover:bg-[#9F583F] hover:text-white hover:border-[#9F583F] transition-colors"
      >
        {copied ? <Check size={15} /> : <Link2 size={15} />}
      </button>
    </div>
  );
};
